import { RNode } from "@/types";
import * as RadixDialog from "@radix-ui/react-dialog";
import Icon from "./Icon";

export default function Modal({
  children,
  trigger,
  title,
  isOpen,
  setOpen,
  disabledClosing,
}: {
  isOpen?: boolean;
  setOpen?: (arg?: boolean) => void;
  children?: RNode;
  trigger?: RNode;
  title?: RNode;
  disabledClosing?: boolean;
}) {
  return (
    <RadixDialog.Root open={isOpen} onOpenChange={setOpen}>
      <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0  bg-black/50" />
        <RadixDialog.Content
          className="fixed
            w-[80vw] max-w-md max-h-[90vh] overflow-auto rd-6 p-6 md:w-full
            top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]
            bg-gray2"
          onEscapeKeyDown={
            disabledClosing
              ? (e) => {
                  e.preventDefault();
                }
              : undefined
          }
          onPointerDownOutside={
            disabledClosing
              ? (e) => {
                  e.preventDefault();
                }
              : undefined
          }
          onInteractOutside={
            disabledClosing
              ? (e) => {
                  e.preventDefault();
                }
              : undefined
          }
        >
          <div className="flex justify-between">
            <RadixDialog.Title className="fw-700">{title}</RadixDialog.Title>
            <RadixDialog.Close asChild>
              <button className="text-gray-800 hover:text-gray-900">
                <Icon name="bf-i-ph-x" />
              </button>
            </RadixDialog.Close>
          </div>
          <RadixDialog.Description className="mt-2 text-sm font-normal text-gray-700 dark:text-gray-400">
            {children}
          </RadixDialog.Description>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}

Modal.Close = RadixDialog.Close;
